window.DocDeadlines = {
	
	prepareFilterForm: function (listingname) {
		var options = {
			success: function (data) {
				DocDeadlines.processFilterForm(data, listingname);
				DocDeadlines.loadRelatedsQtip();
			}, 
			data : {
				action : 'updateList'
			},
			dataType: "json"
		};
		
		MyForm.prepare(listingname+"FilterForm", "docDeadlines", options);
	},
	
	processFilterForm: function (data, listingname) {
		Listing.refresh(listingname+"Listing", data, eval('data.'+data.metadatasName));
	},
	
	loadRelatedsQtip : function(){
		
		$("[tip_type='relateds']").each(function(){
			
			var relatedId = $(this).attr('tip_relid');

			$(this).qtip({
				style : {
					classes : 'custom-qtip rich-qtip mw-300',
					def		: false,
				},
				position: {
					viewport: true,
					my : 'top center',
					at : 'bottom center'
				},
				show : {
					event : 'mouseover'
				},
				hide : {
					event: 'mouseout', 
					fixed: true,
					delay: 100
				},
				content:{
					ajax: {
						url: '/?_f=docDeadlines', 
						type: 'GET',
						data: {
							action		: 'loadRelateds', 
							deadlineid	:  relatedId
						},
						once: true
					}
				}
			});
		});
	},
	
	edit : function(deadlineID) {
		
		var formID	= 'docDeadlineForm';

		var popupOpts = {
			title	 : Loc.g("Editer une échéance"),
			buttons  : [
                {text : Loc.g('Annuler'), click : function(){MyWindow.close();}},
				{text : Loc.g('Enregistrer'), click : function(){$('#'+formID).submit();}}
			],
			callback : function(){
				
				var options = {
					dataType	: 'json',
					data		: {action : 'record', deadlineID : deadlineID},
					beforeSend	: function(){
						$('.alert-danger').remove();
					},
					success		: function(data){
						
						var formOK = MyForm.processJson(data, data.form.formId);
						
						if(formOK){
							Utils.reload();
						}else{
							$('#'+formID).prepend('<div class="alert alert-danger">'+data.form.msg+'</div>');
						}
					}
				};
				
				MyForm.prepare(formID, 'docDeadlines', options, true);
			}
		};
		
		MyWindow.load('docDeadlines', {action : 'editForm', deadlineID : deadlineID}, popupOpts);
		
	}
};
